/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ValidateDealProductVariantsQueryResponse,
  ValidateDealProductVariantsPathParams,
  ValidateDealProductVariants404,
  ValidateDealProductVariants422,
} from '../types/ValidateDealProductVariants'

function getValidateDealProductVariantsUrl({
  import_number,
}: {
  import_number: ValidateDealProductVariantsPathParams['import_number']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/importengine/previews/v2/${import_number}/validate-deal-product-variants/` as const,
  }
  return res
}

/**
 * @summary Validate deal product-variant values against company variants
 * {@link /api/v1/importengine/previews/v2/:import_number/validate-deal-product-variants/}
 */
export async function validateDealProductVariants(
  {
    import_number,
  }: { import_number: ValidateDealProductVariantsPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ValidateDealProductVariantsQueryResponse,
    ResponseErrorConfig<
      ValidateDealProductVariants404 | ValidateDealProductVariants422
    >,
    unknown
  >({
    method: 'GET',
    url: getValidateDealProductVariantsUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
